import React, { FC, RefObject, forwardRef } from "react";
import '../../styles/components/headerFilter.scss';
import { useViewModel } from "../../utils";
import { Button } from "../button";
import { FilterViewModel } from "../filter";
import { HeaderModal } from "../headerModal";
import { Filters } from "./Filters";

interface HeaderFilterProps {
  visibility: boolean;
  onClose: () => void;
}

export const HeaderFilter = forwardRef<HTMLDivElement, HeaderFilterProps>(({ visibility, onClose }, ref: RefObject<HTMLDivElement>) => {
  const filterViewModel = useViewModel(FilterViewModel);

  return (
    visibility && (
      <HeaderModal
        alignContent="l-l"
        onClose={onClose}
        ref={ref}
      >
        <div className="header-filter">
          <div className="filters-area">
            <Filters />
          </div>
          <div className="header-filter-buttons">
            <Button title="Сбросить" onClick={filterViewModel.resetFilters} className="outlined small" />
          </div>
        </div>
      </HeaderModal>
    )
  );
});